import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import Layout from "@common/layout/Layout";
import SectionTable from "./SectionTable";
import sectionsCubeQuery from "../graphql/sectionsCubeQuery.graphql";
import sectionsFilterQuery from "../graphql/sectionsFilterQuery.graphql";
import useGetQueryVariables from "@dimensions/hooks/useGetQueryVariables";
import { SectionPage } from "@models/ISchema";

const SectionSearch: React.FC = () => {
  // Using React Router's useLocation hook to get the query parameters from the URL
  const location = useLocation();
  const params: queryString.ParsedQuery<string> = queryString.parse(location.search);

  // State for managing current page and size per page for pagination
  const [page, setPageCount] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);

  // Get the query variables using the custom hook, based on the URL parameters and pagination settings
  const variables = useGetQueryVariables(params, page, undefined, sizePerPage);

  // Choose the appropriate query based on the 'advance' parameter from the URL
  const queriesSearch = params?.advance ? sectionsFilterQuery : sectionsCubeQuery;

  // Fetch data using the Apollo useQuery hook with the chosen query and variables
  const { loading, error, data } = useQuery(queriesSearch, {
    variables,
    fetchPolicy: "network-only",
  });

  // Assign the fetched data depending on the query used
  let sections: SectionPage = data?.cube?.sections;
  if (params?.advance) sections = data?.filter?.sections;

  // Render the Layout component and pass the sections data to the SectionTable component for display
  return (
    <Layout contextSearch>
      <SectionTable
        data={sections?.items} // Items from sections data
        search={params?.search?.toString()} // Search query from URL
        pageInfo={sections?.pageInfo} // Page information for pagination
        setPage={(value: number) => setPageCount(value)} // Function to update the page number
        loading={loading} // Pass loading state from useQuery
        error={error} // Pass error state from useQuery
        onChangeSizePerPage={setSizePerPage} // Function to update the size of items per page
      />
    </Layout>
  );
};

export default SectionSearch;
